import * as yup from "yup";

export const validationSchemaDrivers = (translations: any) => yup.object().shape({
  lastName: yup.string().required(translations.lastNameRequired).max(50),
  firstName: yup.string().required(translations.firstNameRequired).max(50),
  phone: yup
    .string()
    .nullable()
    .matches(/^([0-9]{9}|\+[0-9]{8,14})$/, { message: translations.phoneInvalid, excludeEmptyString: true }),
  email: yup
    .string()
    .email(translations.emailInvalid)
    .required(translations.emailRequired)
    .max(50),
});
